import Vue from 'vue';

import clickOutside from './clickOutside';
import VueTimers from 'vue-timers';
import './filters';
import Skeleton from 'vue-loading-skeleton';
import KProgress from 'k-progress';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo)


Vue.component('k-progress', KProgress);
Vue.use(Skeleton)
Vue.use(VueTimers);
Vue.use(clickOutside);
